import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 获取用户基本信息
  workeruserinfo(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/visitor/page',
      method: 'get',
      params: args
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/visitormanagement/index.js